
import Vue from 'vue';

export const filterLicenseNo =(val) => {
    if (!val) return ''
    if( val == '*-*' ){
        return '新车'
    }else{
        val = val.toString()
        return val.charAt(0).toUpperCase()
    }
};


// Vue.filter('filterLicenseNo', function (val) {
//     if (!val) return ''
//     if( val == '*-*' ){
//         return '新车'
//     }else{
//         val = val.toString()
//         return val.charAt(0).toUpperCase() + val.slice(1)
//     }
// })

const filterLicenseNo2 = Vue.filter('filterLicenseNo2', function(val){
    if (!val) return ''
    if( val == '*-*' ){
        return '未上牌';
    }else{
        return val;
    }
});

export default {
    filterLicenseNo,filterLicenseNo2,
}
